import script from "./RsoApp.vue?vue&type=script&setup=true&lang=js"
export * from "./RsoApp.vue?vue&type=script&setup=true&lang=js"

import "./RsoApp.vue?vue&type=style&index=0&id=8d45aece&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8d45aece"]])

export default __exports__